export enum AssociationType {
    FSAA = 0,
    AssoUL = 1,
    Partner = 2,
    External = 3,
}